import getInfoBarMessageIdsInReadingPane from './getInfoBarMessageIdsInReadingPane';
import addInfoBarMessageInReadingPane from '../actions/addInfoBarMessageInReadingPane';
import removeInfoBarMessageInReadingPane from '../actions/removeInfoBarMessageInReadingPane';
import ItemViewState from '../store/schema/ItemViewState';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';

const infoBarAddHandler = (viewState: ItemViewState) => (
    messageId: string,
    infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
) => {
    addInfoBarMessageInReadingPane(viewState, messageId, infoBarMessageViewStateCreator);
};

const infoBarRemoveHandler = (viewState: ItemViewState) => (messageId: string) => {
    removeInfoBarMessageInReadingPane(viewState, messageId);
};

const infoBarGetIdsHandler = (viewState: ItemViewState) => () => {
    return getInfoBarMessageIdsInReadingPane(viewState);
};

export { infoBarAddHandler, infoBarRemoveHandler, infoBarGetIdsHandler };
